import { render, staticRenderFns } from "./courierSelection.vue?vue&type=template&id=c261e2a4&"
import script from "./courierSelection.vue?vue&type=script&lang=js&"
export * from "./courierSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports